import { Component } from '@verndale/core';
import axios from 'axios';
import Choices from 'choices.js';
import Schema from 'validate';
import serialize from 'form-serialize';


class RifPartial extends Component {
  setupDefaults() {
    this.dom = {
      $location: this.el.querySelector('[data-field="partial-location"]'),
      $locationSelect: this.el.querySelector('[data-field="partial-location"] .rif__field--select'),
      $programSelect: this.el.querySelector('[data-field="partial-program"] .rif__field--select'),
      $form: this.el.querySelector('.rif-partial__form'),
      $rif: document.querySelector('.rif')
    };
    this.selectText = this.dom.$location.querySelector('option').innerHTML;
    this.styleSelect();
    this.getData();
  }

  addListeners() {
    this.dom.$form.addEventListener('submit', :: this.onSubmit);
    this.dom.$location.addEventListener('choice', :: this.updatePrograms);
  }

  styleSelect() {
    const defaultOptions = {
      itemSelectText: '',
      searchEnabled: false,
      shouldSort: false
    };
    this.locationChoices = new Choices(this.dom.$locationSelect, defaultOptions);
    this.locationChoices.containerOuter.element.setAttribute('aria-label', this.el.dataset.location);

    this.programChoices = new Choices(this.dom.$programSelect, defaultOptions);
    this.programChoices.containerOuter.element.setAttribute('aria-label', this.el.dataset.program);
  }

  setLocationAndProgram(locations, newLocation, newProgram) {
    if (locations && locations.length) {
      this.locationChoices
        .setChoices(locations.map(({ value, label, programs }) => (
          { value, label, customProperties: { programs } }
        )), 'value', 'label', false)
        .enable();

      if (location) {
        const location = locations.find(({ value }) => String(value) === String(newLocation));
        if (!location) return;
        this.locationChoices.setChoiceByValue(newLocation);

        const programs = [{ label: this.selectText, value: '' }, ...location.programs];
        this.programChoices
          .setValue({ label: this.selectText, value: 'select' })
          .setChoices(programs.map(({ value, label }) => (
            { value, label }
          )), 'value', 'label', true)
          .enable();

        if (newProgram && programs.find(({ value }) => String(value) === String(newProgram))) {
          this.programChoices.setChoiceByValue(newProgram);
        }
      }
    }
  }

  async getData() {
    const url = this.el.dataset.rifEndpoint;
    const currentLocation = this.el.dataset.currentLocation;
    const currentProgram = this.el.dataset.currentProgram;
    const { data } = await axios.get(url);

    this.setLocationAndProgram(data.locations, currentLocation, currentProgram)

  }

  updatePrograms(e) {
    let { programs } = e.detail.choice.customProperties;
    programs = [{ label: this.selectText, value: '' }, ...programs];
    this.programChoices
      .setValue({ label: this.selectText, value: 'select' })
      .setChoices(programs.map(({ value, label }) =>
        ({ value, label })
      ), 'value', 'label', true)
      .enable();
  }

  onSubmit(e) {
    e.preventDefault();
    const data = this.getFormObject(e.target);
    const errors = this.createStep1ValidationSchema().validate(data);
    this.updateFormState(errors, this.dom.$form);
    if (errors.length) return;
    const location = data['partial-location'];
    const program = data['partial-program']
    if (this.dom.$rif) {
      // eslint-disable-next-line no-undef
      const event = new CustomEvent(
        'fill-rif-from-partial',
        { detail: { location, program } }
      );
      window.dispatchEvent(event);
    } else {
      const { rifPageUrl } = this.el.dataset;
      window.location = `${rifPageUrl}?location=${location}&program=${program}`
    }
  }

  updateFormState(errors, form) {
    let count = 0;

    this.resetFormStatus(form);

    errors.forEach(err => {
      const field = form.querySelector(`[data-field=${err.path}]`);
      if (field) {
        const error = field.querySelector('.rif__error-wrapper');
        field.classList.add('error');
        error.innerHTML = `
            <em class="rif__error">
                <span><svg><use xlink:href="#warning"></use></svg></span>
                ${err.message}
            </em>
        `;
        count = count + 1;
      }
    })

    return count;
  }

  resetFormStatus(form) {
    form.querySelectorAll('.rif__field-wrapper').forEach(el => {
      const error = el.querySelector('.rif__error-wrapper');
      el.classList.remove('error');
      error.innerHTML = '';
    })
  }

  getFormObject(form) {
    const obj = {};
    form.querySelectorAll('.rif__field-wrapper').forEach(el => {
      const { field } = el.dataset;
      obj[field] = el.querySelector('.rif__field').value;
    })
    return obj;
  }

  createStep1ValidationSchema() {
    const isPlaceholder = val => val !== 'select';
    return new Schema({
      'partial-location': {
        type: String,
        required: true,
        message: {
          required: this.getErrorMessage('partial-location', 'required')
        }
      },
      'partial-program': {
        type: String,
        required: true,
        use: { isPlaceholder },
        message: {
          required: this.getErrorMessage('partial-program', 'required'),
          use: this.getErrorMessage('partial-program', 'required')
        }
      }
    })
  }

  getErrorMessage(field, type) {
    return this.el.querySelector(`[data-field=${field}]`).querySelector('.rif__field').getAttribute(`data-msg-${type}`);
  }
}

export default RifPartial;
